import React from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';

export const DollarInputAdornment = () => (
  <InputAdornment classes={{ root: 'dollar-adornment override' }} position="start">
    $
  </InputAdornment>
);
